import en from './en'
import jp from './jpn'

export default {
    ...en,...jp
}